const UNKNOWN_ERROR_STATUS = "Fel";
const UNKNOWN_ERROR_MESSAGE = "Ett oväntat fel inträffade";

export const formatError = (error?: unknown): { status: string; message: string } => {
  let status = UNKNOWN_ERROR_STATUS;
  let message = UNKNOWN_ERROR_MESSAGE;

  if (!error || typeof error !== "object") {
    return { status, message };
  }

  if (error.hasOwnProperty("status")) {
    if (typeof (error as { status?: unknown }).status === "string") {
      status = (error as { status?: unknown }).status as string;
    } else {
      status = JSON.stringify((error as { status?: unknown }).status) || UNKNOWN_ERROR_STATUS;
    }
  }

  if (error.hasOwnProperty("message")) {
    if (typeof (error as { message?: unknown }).message === "string") {
      message = (error as { message?: unknown }).message as string;
    } else {
      message = JSON.stringify((error as { message?: unknown }).message) || UNKNOWN_ERROR_MESSAGE;
    }
  } else if (error.hasOwnProperty("data")) {
    if (typeof (error as { data?: unknown }).data === "string") {
      message = (error as { data?: unknown }).data as string;
    } else {
      message = JSON.stringify((error as { data?: unknown }).data) || UNKNOWN_ERROR_MESSAGE;
    }
  }

  return { status, message };
};
